import React from 'react';
import { Link } from 'react-router-dom';
import ServicePlan from '../components/ServicePlan';
import { CheckCircleIcon } from 'lucide-react';
const Home = () => {
  return <div className="w-full" data-id="element-322">
      {/* Hero Section */}
      <section className="relative h-[600px]" data-id="element-323">
        <div className="absolute inset-0 bg-[#8B4513]/60 z-10" data-id="element-324"></div>
        <div className="absolute inset-0 bg-cover bg-center" style={{
        backgroundImage: "url('https://uploadthingy.s3.us-west-1.amazonaws.com/hJYDxYcMCGH5nikhbiEaxH/here-blog.webp')"
      }} data-id="element-325"></div>
        <div className="container mx-auto px-4 h-full flex items-center relative z-20" data-id="element-326">
          <div className="max-w-2xl text-white" data-id="element-327">
            <h1 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-328">
              Fast, Reliable Appliance Repairs Across the UK
            </h1>
            <p className="text-xl mb-8" data-id="element-329">
              Professional service with fixed prices and UK-based support
            </p>
            <div className="flex flex-col sm:flex-row gap-4" data-id="element-330">
              <Link to="/contact-us" className="bg-[#F8B179] hover:bg-[#FFD28F] text-white font-medium py-3 px-8 rounded-md transition-colors duration-300 text-center" data-id="element-331">
                Contact Us
              </Link>
              <Link to="/service-coverage" className="bg-white hover:bg-gray-100 text-[#E57C23] font-medium py-3 px-8 rounded-md transition-colors duration-300 text-center" data-id="element-332">
                Our Services
              </Link>
            </div>
          </div>
        </div>
      </section>
      {/* Intro Section */}
      <section className="py-16 bg-white" data-id="element-333">
        <div className="container mx-auto px-4" data-id="element-334">
          <div className="max-w-3xl mx-auto text-center" data-id="element-335">
            <h2 className="text-3xl font-bold text-[#E57C23] mb-6" data-id="element-336">
              Welcome to Realmpoint
            </h2>
            <p className="text-lg text-gray-600 mb-8" data-id="element-337">
              We provide professional appliance repair and maintenance services
              across the UK. Our team of expert engineers is dedicated to
              delivering reliable, efficient solutions for all your household
              appliance needs. With transparent pricing and exceptional customer
              service, we ensure your appliances are in safe hands.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-338">
              <div className="p-4 border border-gray-200 rounded-lg" data-id="element-339">
                <div className="w-12 h-12 bg-[#FFF8F0] rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-340">
                  <CheckCircleIcon className="w-6 h-6 text-[#F8B179]" data-id="element-341" />
                </div>
                <h3 className="font-bold text-[#E57C23] mb-2" data-id="element-342">
                  Reliable Service
                </h3>
                <p className="text-gray-600" data-id="element-343">
                  Expert technicians with years of experience
                </p>
              </div>
              <div className="p-4 border border-gray-200 rounded-lg" data-id="element-344">
                <div className="w-12 h-12 bg-[#FFF8F0] rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-345">
                  <CheckCircleIcon className="w-6 h-6 text-[#F8B179]" data-id="element-346" />
                </div>
                <h3 className="font-bold text-[#E57C23] mb-2" data-id="element-347">Fixed Pricing</h3>
                <p className="text-gray-600" data-id="element-348">
                  Transparent costs with no hidden charges
                </p>
              </div>
              <div className="p-4 border border-gray-200 rounded-lg" data-id="element-349">
                <div className="w-12 h-12 bg-[#FFF8F0] rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-350">
                  <CheckCircleIcon className="w-6 h-6 text-[#F8B179]" data-id="element-351" />
                </div>
                <h3 className="font-bold text-[#E57C23] mb-2" data-id="element-352">
                  UK-Based Support
                </h3>
                <p className="text-gray-600" data-id="element-353">
                  Local engineers available nationwide
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Service Plans Section */}
      <section className="py-16 bg-[#FFF8F0]" data-id="element-354">
        <div className="container mx-auto px-4" data-id="element-355">
          <div className="text-center mb-12" data-id="element-356">
            <h2 className="text-3xl font-bold text-[#E57C23] mb-4" data-id="element-357">
              Our Service Plans
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-358">
              Choose the perfect plan for your needs with our comprehensive
              coverage options.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-359">
            <ServicePlan title="One-Year Service Plan – 1 Appliance" price="£99.00" description="Reliable cover for your appliance with 12 months of unlimited repairs, priority support, and expert engineer care." imageUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/2UhiroBKcLFx5tcosZWgt5/12._Washing_Machine.png" imageAlt="Washing machine" buttonLink="https://buy.stripe.com/fZuaEZ3Cs3HF9Wgb2P3ZK01" data-id="element-360" />
            <ServicePlan title="One-Year Service Plan – TV + Set-Top Box" price="£120.00" description="Protect your home entertainment with unlimited repairs and rapid-response service for your TV and set-top box." imageUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/6fCvMKQ8fmGfo711VSpGc1/3.png" imageAlt="TV repair" buttonLink="https://buy.stripe.com/eVq3cx5KA91Z1pK0ob3ZK00" data-id="element-361" />
          </div>
        </div>
      </section>
      {/* Protect Your Home Section */}
      <section className="py-16 bg-white" data-id="element-362">
        <div className="container mx-auto px-4" data-id="element-363">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-364">
            <div data-id="element-365">
              <h2 className="text-3xl font-bold text-[#E57C23] mb-6" data-id="element-366">
                Protect the Items in Your Home
              </h2>
              <p className="text-lg text-gray-600 mb-6" data-id="element-367">
                At Realmpoint, we understand how important your household
                appliances are to your daily life. That's why our team of highly
                skilled and experienced technicians is committed to delivering
                exceptional repair services you can rely on.
              </p>
              <p className="text-lg text-gray-600 mb-6" data-id="element-368">
                We don't just fix appliances, we provide lasting solutions that
                keep your home running smoothly and efficiently. When you choose
                Realmpoint, you gain more than just expert repairs.
              </p>
              <p className="text-lg text-gray-600" data-id="element-369">
                Our comprehensive service plans are designed to offer you
                complete peace of mind, covering your appliances with reliable
                protection and prompt support whenever you need it. We
                prioritise transparency, honesty, and clear communication, so
                you always know what to expect.
              </p>
            </div>
            <div data-id="element-370">
              <img src="https://images.unsplash.com/photo-1556911220-e15b29be8c8f?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80" alt="Modern kitchen with appliances" className="rounded-lg shadow-lg" data-id="element-371" />
            </div>
          </div>
        </div>
      </section>
      {/* Testimonial Section */}
      <section className="py-16 bg-[#FFF8F0]" data-id="element-372">
        <div className="container mx-auto px-4" data-id="element-373">
          <div className="max-w-3xl mx-auto text-center" data-id="element-374">
            <h2 className="text-3xl font-bold text-[#E57C23] mb-12" data-id="element-375">
              What Our Customers Say
            </h2>
            <div className="bg-white p-8 rounded-lg shadow-md" data-id="element-376">
              <div className="flex justify-center mb-6" data-id="element-377">
                <div className="flex" data-id="element-378">
                  {[...Array(5)].map((_, i) => <svg key={i} className="w-6 h-6 text-yellow-400" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" data-id="element-379">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-380"></path>
                    </svg>)}
                </div>
              </div>
              <blockquote className="text-lg text-gray-600 italic mb-6" data-id="element-381">
                "Realmpoint's service was exceptional. The engineer arrived
                promptly, diagnosed the issue with our washing machine quickly,
                and had it working perfectly within the hour. Highly recommended
                for their professionalism and expertise."
              </blockquote>
              <p className="font-bold text-[#E57C23]" data-id="element-382">
                Sarah Thompson, Newcastle
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="py-16 bg-[#E57C23] text-white" data-id="element-383">
        <div className="container mx-auto px-4 text-center" data-id="element-384">
          <h2 className="text-3xl font-bold mb-6" data-id="element-385">
            Ready to Protect Your Appliances?
          </h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto" data-id="element-386">
            Join thousands of satisfied customers who trust Realmpoint for
            dependable, professional, and friendly service.
          </p>
          <Link to="/contact-us" className="bg-white text-[#E57C23] hover:bg-gray-100 font-medium py-3 px-8 rounded-md transition-colors duration-300 inline-block" data-id="element-387">
            Contact Us Today
          </Link>
        </div>
      </section>
    </div>;
};
export default Home;